import { OnInit, Component, EventEmitter, Output } from "@angular/core";
import { SharedService } from "../../shared/shared.service";

@Component({
  selector: "choose-auth-method",
  templateUrl: "./choose-auth-method.component.html",
})
export class ChooseAuthMethodComponent implements OnInit {
  @Output() authMethodChosen = new EventEmitter<any>();
  public authMethod: any;

  constructor(public sharedService: SharedService) {}
  ngOnInit() {}

  goToChosenAuthMethod() {
    this.authMethodChosen.emit(this.authMethod);
  }
}
